module.exports = __webpack_public_path__ + "r-v3/img/chatbot.f4c0219d.png";